import { z } from 'zod';

export const zGeneralConfig = z.object({
  VITE_AUTH0_DOMAIN: z.string(),
  VITE_AUTH0_CLIENT_ID: z.string(),
  VITE_AUTH0_CALLBACK_URL: z.string().url(),
  VITE_AUTH0_AUDIENCE: z.string(),
  VITE_API_SERVER_URL: z.string().url(),

  PROD: z.boolean(),
});

export type GeneralConfig = z.infer<typeof zGeneralConfig>;

export const generalConfig = zGeneralConfig.parse(import.meta.env);
